"use client";

import { QuizCalloutBlock } from "./components/quiz-callout-block";

interface QuizFeedbackProps {
  selected: number[];
  isCompleted: boolean;
  multipleChoiceMessage: string;
  finalAnswerMessage: string;
  selectedOptionComment: any[];
  quizComment: any[];
  correct: number[];
}

function areAllCorrectSelected(selected: number[], correct: number[]): boolean {
  return (
    selected.length === correct.length &&
    selected.every((id) => correct.includes(id))
  );
}

function wasIncorrectSelected(selected: number[], correct: number[]): boolean {
  return selected.some((id) => !correct.includes(id));
}

export function QuizFeedback({
  selected,
  isCompleted,
  multipleChoiceMessage,
  finalAnswerMessage,
  selectedOptionComment,
  quizComment,
  correct,
}: QuizFeedbackProps) {
  const blocks =
    selectedOptionComment && selectedOptionComment.length > 0
      ? selectedOptionComment
      : quizComment ?? [];

  return (
    <>
      {selected.length > 0 && !isCompleted && (
        <QuizCalloutBlock
          contentBlocks={blocks}
          title={multipleChoiceMessage}
          variant="comment"
        />
      )}

      {selected.length >= 1 && isCompleted && finalAnswerMessage && (
        <QuizCalloutBlock
          contentBlocks={
            selected.length > 1 && !wasIncorrectSelected(selected, correct)
              ? quizComment
              : blocks
          }
          title={finalAnswerMessage}
          variant={areAllCorrectSelected(selected, correct) ? "good" : "bad"}
        />
      )}
    </>
  );
}
